/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services';

interface CategoryResponse {
  data: {
    data?: any;
  };
}

interface UserCollectionResponse {
  data: any;
}

interface UserResponse {
  data: {
    data: any[];
  };
}

interface RoleResponse {
  data: {
    data: any[];
  };
}

interface UserParams {
  // Define the structure of your user creation params
  [key: string]: any;
}

export const userActions = {
  createUserByAdmin,
  getCategories,
  getUserCollections,
  getUsersByRoleId,
  getAllUsersByRoleId,
  getCategoriesForAdmin,
  getRoles,
  getAmenities,
};

function getCategoriesForAdmin(): Promise<any> {
  const response = services.get<CategoryResponse>(`/category/list?list=all`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching categories for admin');
    }
  });
}

function getCategories(): Promise<any> {
  const response = services.get<CategoryResponse>(`/asset-type`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching categories');
    }
  });
}

function getUserCollections(user_id: string | number): Promise<any> {
  const response = services.get<UserCollectionResponse>(`/nft/listCollection/${user_id}`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching user collections');
    }
  });
}

function getUsersByRoleId(roleId: string | number): Promise<any[]> {
  const response = services.get<UserResponse>(`/user/list?roleId=${roleId}`);
  return response.then((promise) => {
    if (promise && 'data' in promise && Array.isArray(promise.data.data)) {
      return promise.data.data;
    }
    return Promise.reject('Error fetching users by role ID');
  });
}

function getAllUsersByRoleId(roleId: string | number): Promise<any[]> {
  const response = services.get<UserResponse>(`/user/list?pagination=false`);
  return response.then((promise) => {
    if (promise && 'data' in promise && Array.isArray(promise.data.data)) {
      return promise.data.data;
    }
    return Promise.reject('Error fetching all users by role ID');
  });
}

function getRoles(): Promise<any[]> {
  const response = services.get<RoleResponse>(`/user/getRoles`);
  return response.then((promise) => {
    if (promise && 'data' in promise && Array.isArray(promise.data.data)) {
      return promise.data.data;
    }
    return Promise.reject('Error fetching roles');
  });
}

function createUserByAdmin(params: UserParams): Promise<any> {
  const response = services.post<any>(`/user/addNewUserByAdmin`, params);
  return response.then((promise) => {
    if (promise) {
      return promise;
    } else {
      return Promise.reject('Error creating user by admin');
    }
  });
}

function getAmenities(): Promise<any> {
  const response = services.get<{ data: any[] }>(`/amenity/list`);
  return response.then((promise) => {
    if (promise && 'data' in promise) {
      return promise.data;
    } else {
      return Promise.reject('Error fetching amenities');
    }
  });
}
